const Action = require("../../entities/Action");
const {Age}  = require("../Constants");
const ActionNames = require("../Names/ActionNames");

class MilitaryBuildup extends Action {
    constructor(age){
        super(
            age,
            ActionNames.MilitaryBuildup, 
            `For each civilization stronger than yours, you have extra resource for building and upgrading military units this round:
            ${MilitaryBuildup.GetFourPlayerValue(age)} in a 4-player game
            ${MilitaryBuildup.GetThreePlayerValue(age)} in a 3-player game
            ${MilitaryBuildup.GetTwoPlayerValue(age)} in a 2-player game`,
            {
                playerStateAltering:
                (playerState) => {
                    //Do stuff
                }
            },
            {}
        )
    }

    static GetName(age){
        switch (age)
        {
            default:
                return null;
            case Age.Age2:
                return "Wave of Nationalism";
            case Age.Age3:
                return "Military Buildup";
        }
    }

    static GetTwoPlayerValue(age){
        switch (age)
        {
            default:
                return null;
            case Age.Age2:
                return 6;
            case Age.Age3:
                return 8;
        }
    }

    static GetThreePlayerValue(age){
        switch (age)
        {
            default:
                return null;
            case Age.Age2:
                return 3;
            case Age.Age3:
                return 5;
        }
    }

    static GetFourPlayerValue(age){
        switch (age)
        {
            default:
                return null;
            case Age.Age2:
                return 2;
            case Age.Age3:
                return 3;
        }
    }
}

module.exports = MilitaryBuildup;
